<!-- Content Header (Page header) -->
<section class="content-header">
    <div class="content-header">
       <div class="container-fluid">
         <div class="row mb-2">
           <div class="col-sm-6">
               <h3>Export Stock</h3>
           </div>
           <div class="col-sm-6">
             <ol class="breadcrumb float-sm-right">
               <li class="breadcrumb-item"><a routerLink="/"><i class="nav-icon fas fa-tachometer-alt"></i>&nbsp;Dashboard</a></li>
               <li class="breadcrumb-item active">Export Stock</li>
             </ol>
           </div><!-- /.col -->
         </div><!-- /.row -->
       </div><!-- /.container-fluid -->
    </div>
</section>
<!-- /.content-header -->
<section class="content">
    <div class="container-fluid">
        <div class="card">
            <!--Error Message-->
            <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
                {{errorMessage}}
            </div>
            <!--Warning Message-->
            <div class="alert alert-warning" role="alert" *ngIf="warningMessage">
                {{warningMessage}}
            </div>

             <!--Success Message-->
             <div class="alert alert-success" role="alert" *ngIf="successMessage">
                {{successMessage}}
            </div>
            <div class="card-body">
                <form [formGroup]="form" (ngSubmit)="handleSubmit()">
                    <div class="row clearfix">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Location:<span style="color:red;">*</span></label>
                                <select formControlName="location" class="form-control"  (change)="onLocationChange($event.target)">
                                    <option value="">Select</option>
                                    <option value="all">All</option>
                                    <option value="enroute">En route</option>
                                    <option value="on_port">On Port/CFS</option>
                                    <option [value]="location.id" *ngFor="let location of locations">{{ location.location_name }}</option>
                                </select>

                                <span *ngIf="submitted && form.get('location')?.hasError('required')" style="color:red"> <strong>Location is required!</strong></span>
                            </div>
                        </div>
                        <div class="col-md-4" *ngIf="showBranchDropdown">
                            <div class="form-group">
                                <label>Branch:</label>
                                <select formControlName="branch" class="form-control">
                                    <option value="">Select</option>
                                    <option value="all">All</option>
                                    <option [value]="branch.id" *ngFor="let branch of branches">{{ branch.branch_name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <button class="btn btn-success" type="button" *ngIf="isProcessing; else showSaveBtn" disabled>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Processing...
                    </button>
    
                    <ng-template #showSaveBtn>
                        <button type="submit" class="btn btn-success"><i class="fas fa-file-excel" aria-hidden="true">&nbsp;</i>Export</button>
                    </ng-template>
                </form>
            </div>
        </div>
    </div>
</section>